import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        mode: 'light',
    },
    // you can customize breakpoints here if needed
    // breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } }
});

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
    </ThemeProvider>
);
